module.exports = __webpack_public_path__ + "media/images/instagram-c26330097ecb27336cc1cdc250993188.png";